import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import ExtendedLink  from "../components/ExtendedLink";

class FourOhFour extends Component {
    render() {
        const { settings, t } = this.props;
        return (
            <div className="container padding-top-3x padding-bottom-3x mb-1">
                <img
                    className="d-block m-auto image-404"
                    src="img/404_art.jpg"
                    alt="404"
                />
                <div className="padding-top-1x mt-2 text-center">
                    <h3>{t("Page Not Found")} </h3>
                    <p>
                        {t("It seems we can’t find page you are looking for.")}
                        <ExtendedLink to={settings.baseUrl}>{t("Go back to Homepage")}</ExtendedLink>
                        <br />{t("Or try using search at the top right corner of the page.")}
                    </p>
                </div>
            </div>
        );
    }
}


function mapStateToProps({ settings }, ownProps) {
    return { settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(FourOhFour));

